export default function Accordion() {
	// Options to limit to one active accordion
	var options = {
		limitToOneOpen: true,
	};

	// Set the triggers for the Accordions
	var accordionElements = document.querySelectorAll('.js-accordion-trigger');

	// Check if we have accordions
	if (accordionElements.length) {
		// Setup our accordions array
		var accordions = [];

		// Loop over the accordions
		accordionElements.forEach(function(accordionElement) {
			// Create an accordion item object
			var accordion = {
				element: accordionElement,
				parent: accordionElement.parentNode,
				content: accordionElement.parentNode.querySelector('.js-accordion-content'),
				height: 0,
				active: false,
			};

			// Check for parent and content elements
			if (accordion.parent && accordion.content) {
				// Push the accordion item into the accordions array
				accordions.push(accordion);

				// Add a click event listener to the accordion trigger
				accordion.element.addEventListener('click', function() {
					// Set the heights on click
					setAccordionHeights(accordions);

					// Toggle the 'active' class on the accordion trigger
					accordion.element.classList.toggle('active');

					// Toggle the active state of the accordion
					accordion.active = !accordion.active;

					// Check if the item is expanded or collapsed
					if (accordion.active) {
						// Expand the accordion

						// Close other accordions if limitToOneOpen is enabled
						if (options.limitToOneOpen) {
							closeNonActiveAccordions(accordion, accordions);
						}

						// Set the content height based on the stored height value
						accordion.content.style.height = accordion.height + 'px';
					} else {
						// Collapse the accordion

						// Set the height to 0 to collapse the content (delayed for smooth transition)
						setTimeout(function() {
							accordion.content.style.height = '0px';
						}, 0);
					}
				});
			}
		});

		// Set the heights initially and on window resize
		setAccordionHeights(accordions);
		window.addEventListener('resize', function() {
			setAccordionHeights(accordions);
		});
	}

	// Helper function to set the heights of the accordions
	function setAccordionHeights(accordions) {
		accordions.forEach(function(accordion) {
			// Set the content height to auto to measure its natural height
			accordion.content.style.height = 'auto';

			// Store the height of the accordion's content
			accordion.height = accordion.content.scrollHeight;

			// Set the content height back to 0 if the accordion is not active, or to its stored height if active
			accordion.content.style.height = accordion.active ? accordion.height + 'px' : '0px';
		});
	}

	// Close all accordions except the active one
	function closeNonActiveAccordions(accordionToExclude, accordions) {
		// Filter the accordions to close, excluding the active one
		var accordionsToClose = accordions.filter(function(accordion) {
			return accordion !== accordionToExclude;
		});

		accordionsToClose.forEach(function(accordion) {
			// Collapse the accordion content
			accordion.content.style.height = '0px';

			// Remove the 'active' class from the accordion trigger
			accordion.element.classList.remove('active');

			// Set the active status to false
			accordion.active = false;
		});
	}
}
